import Link from 'next/link'

import AndroidHandler from 'utils/androidHandler'

import type { LinkProps } from 'next/link'

export type TAnchorProps = {
  href: string
  children: React.ReactNode
} & LinkProps

export const Anchor = (props: TAnchorProps) => {
  const { href, children, ...linkProps } = props
  const androidHandler = AndroidHandler()
  const isAndroid = androidHandler.enabled

  if (isAndroid) {
    // if children tag is anchor tag, return it
    if (children && typeof children === 'object') {
      const child = children as React.ReactElement
      if (child.type === 'a') {
        return <>{children}</>
      }
    }

    return (
      <a href={href} {...linkProps}>
        {children}
      </a>
    )
  }

  return (
    <Link href={href} {...linkProps} legacyBehavior>
      {children}
    </Link>
  )
}
